import styled from 'styled-components'
import tw from 'twin.macro'

export const AppsListLoadingWrapper = styled.div`
   ${tw`flex-grow w-16 mb-4  flex flex-col overflow-x-hidden overflow-y-auto`}
`
export const AppLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-self: flex-end;
   align-items: center;
   flex-shrink: 0;
   cursor: pointer;
   width: 100%;
   margin-bottom: 8px;
   height: 56px;
   margin-left: 0.25rem;
`
